
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 68.03 68.03"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.773.113c-5.717 0-10.411 4.696-10.411 10.413v3.786a2.84 2.84 0 005.68 0v-3.786c0-2.648 2.085-4.736 4.732-4.733l17.462.017s.088 6.05.088 9.065c0 5.717 4.695 10.412 10.412 10.412h7.063v32.466a4.69 4.69 0 01-4.733 4.733H21.772a4.69 4.69 0 01-4.733-4.733v-1.79a2.84 2.84 0 00-5.68 0v1.79c0 5.717 4.696 10.413 10.413 10.413h30.292c5.717 0 10.413-4.696 10.413-10.413V22.196c0-2.565-.95-5.042-2.663-6.952L49.358 3.574A10.426 10.426 0 0041.6.114zm23.23 7.196s7.253 8.17 10.804 12.299h-6.072a4.69 4.69 0 01-4.733-4.733z"}}),_c('path',{attrs:{"d":"M20.185 16.58c2.21 0 4.33.803 5.894 2.23 1.564 1.43 2.441 3.37 2.441 5.39v14.373c0 2.783-1.209 5.452-3.362 7.42-2.154 1.968-5.076 3.072-8.121 3.072-3.046 0-5.968-1.104-8.122-3.072-2.153-1.968-3.362-4.637-3.362-7.42v-11.63c0-1.031.916-1.869 2.046-1.869 1.129 0 2.045.838 2.045 1.87v11.629c0 1.791.78 3.509 2.166 4.775 1.386 1.267 3.266 1.982 5.227 1.982 1.96 0 3.843-.715 5.23-1.982 1.386-1.266 2.165-2.984 2.165-4.775V24.2c0-1.03-.448-2.017-1.244-2.745-.796-.727-1.877-1.136-3.003-1.136-1.127 0-2.207.409-3.003 1.136-.797.728-1.245 1.715-1.245 2.745v13.196c0 .132.029.263.084.385.055.122.137.234.24.328.101.093.222.168.355.219.133.05.276.076.42.076.293 0 .574-.106.78-.295a.967.967 0 00.323-.713V27.073c0-1.032.917-1.87 2.046-1.87 1.129.001 2.042.839 2.042 1.87v10.323c0 1.258-.546 2.465-1.52 3.354-.973.89-2.294 1.389-3.67 1.389-.682 0-1.358-.12-1.988-.358a5.254 5.254 0 01-1.683-1.03 4.739 4.739 0 01-1.125-1.539 4.395 4.395 0 01-.395-1.816V24.2c0-2.02.877-3.96 2.441-5.39 1.564-1.428 3.687-2.23 5.898-2.23z"}})])
          )
        }
      }
    